import type { HttpClient } from '../http/types';
import { createAreasApi } from './areas';
import { createAuthApi } from './auth';
import { createAttachmentsApi } from './attachments';
import { createCollaboratorsApi } from './collaborators';
import { createCustomersApi } from './customers';
import { createOrganizationStructureApi } from './organization-structure';
import { createProjectsApi } from './projects';
import { createTimesheetApi } from './timesheet';
import {
  createWorkBoardApi,
  createProjectViewApi,
  createWorkItemsApi,
  createWorkItemSectionsApi,
  createWorkItemTypesApi,
  createTaskListsApi,
} from './work-items';
import { createTasksApi, createTaskTypesApi } from './tasks';

export * from './areas';
export * from './auth';
export * from './attachments';
export * from './collaborators';
export * from './customers';
export * from './endpoints';
export * from './organization-structure';
export * from './projects';
export * from './timesheet';
export * from './work-items';
export * from './tasks';

/** Agrega todos os modulos de API sobre um mesmo HttpClient. */
export function createApi(http: HttpClient) {
  return {
    areas: createAreasApi(http),
    auth: createAuthApi(http),
    attachments: createAttachmentsApi(http),
    collaborators: createCollaboratorsApi(http),
    customers: createCustomersApi(http),
    organizationStructure: createOrganizationStructureApi(http),
    projects: createProjectsApi(http),
    timesheet: createTimesheetApi(http),
    workItems: createWorkItemsApi(http),
    workBoard: createWorkBoardApi(http),
    projectView: createProjectViewApi(http),
    workItemSections: createWorkItemSectionsApi(http),
    workItemTypes: createWorkItemTypesApi(http),
    taskLists: createTaskListsApi(http),
    tasks: createTasksApi(http),
    taskTypes: createTaskTypesApi(http),
  };
}

export type Api = ReturnType<typeof createApi>;
